import { defineMessages } from 'react-intl';

export default defineMessages({
    policyLevelCoverages: {
        id: 'wmic.pe-capability-quoteandbind-cp-react.wmicpropertylinecoverages.policyLevelCoverages',
        defaultMessage: 'Policy Level Coverages'
    },
});
